/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Company } from '../models';
// @ts-ignore
import { CompanySaveconsultantsorderPostRequest } from '../models';
// @ts-ignore
import { Person } from '../models';
/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a all child companies of authed user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        childCompaniesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/childCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific company
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        childCompaniesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('childCompaniesIdGet', 'id', id)
            const localVarPath = `/childCompanies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a company sign
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyIdCompanysignGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('companyIdCompanysignGet', 'id', id)
            const localVarPath = `/company/{id}/companysign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to delete a company
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('companyIdDelete', 'id', id)
            const localVarPath = `/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get company employees
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyIdEmployeesGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('companyIdEmployeesGet', 'id', id)
            const localVarPath = `/company/{id}/employees`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific company
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('companyIdGet', 'id', id)
            const localVarPath = `/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update company data
         * @param {number} id The id of the company to retrieve
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyIdPut: async (id: number, company?: Company, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('companyIdPut', 'id', id)
            const localVarPath = `/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save default consultants for company
         * @param {CompanySaveconsultantsorderPostRequest} companySaveconsultantsorderPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companySaveconsultantsorderPost: async (companySaveconsultantsorderPostRequest: CompanySaveconsultantsorderPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companySaveconsultantsorderPostRequest' is not null or undefined
            assertParamExists('companySaveconsultantsorderPost', 'companySaveconsultantsorderPostRequest', companySaveconsultantsorderPostRequest)
            const localVarPath = `/company/saveconsultantsorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companySaveconsultantsorderPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all consultants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getconsultantsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/getconsultants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all parent companies
         * @param {string} [companyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parentCompaniesGet: async (companyType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parentCompanies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (companyType !== undefined) {
                localVarQueryParameter['companyType'] = companyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * save extra costs for l1 and damageassessors
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveExtraCostsPut: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveExtraCostsPut', 'body', body)
            const localVarPath = `/saveExtraCosts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update company data
         * @param {number} wmi the wmi of the manufacturer
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wmiWmiPut: async (wmi: number, company?: Company, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wmi' is not null or undefined
            assertParamExists('wmiWmiPut', 'wmi', wmi)
            const localVarPath = `/wmi/{wmi}`
                .replace(`{${"wmi"}}`, encodeURIComponent(String(wmi)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a all child companies of authed user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async childCompaniesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.childCompaniesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a specific company
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async childCompaniesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.childCompaniesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a company sign
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyIdCompanysignGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyIdCompanysignGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to delete a company
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get company employees
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyIdEmployeesGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyIdEmployeesGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a specific company
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update company data
         * @param {number} id The id of the company to retrieve
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyIdPut(id: number, company?: Company, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyIdPut(id, company, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Save default consultants for company
         * @param {CompanySaveconsultantsorderPostRequest} companySaveconsultantsorderPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companySaveconsultantsorderPost(companySaveconsultantsorderPostRequest: CompanySaveconsultantsorderPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companySaveconsultantsorderPost(companySaveconsultantsorderPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all consultants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getconsultantsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getconsultantsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all parent companies
         * @param {string} [companyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parentCompaniesGet(companyType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parentCompaniesGet(companyType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * save extra costs for l1 and damageassessors
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveExtraCostsPut(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveExtraCostsPut(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update company data
         * @param {number} wmi the wmi of the manufacturer
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wmiWmiPut(wmi: number, company?: Company, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wmiWmiPut(wmi, company, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyApiFp(configuration)
    return {
        /**
         * Get a all child companies of authed user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        childCompaniesGet(options?: any): AxiosPromise<Company> {
            return localVarFp.childCompaniesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific company
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        childCompaniesIdGet(id: number, options?: any): AxiosPromise<Company> {
            return localVarFp.childCompaniesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a company sign
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyIdCompanysignGet(id: number, options?: any): AxiosPromise<Company> {
            return localVarFp.companyIdCompanysignGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to delete a company
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.companyIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get company employees
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyIdEmployeesGet(id: number, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.companyIdEmployeesGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific company
         * @param {number} id The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyIdGet(id: number, options?: any): AxiosPromise<Company> {
            return localVarFp.companyIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update company data
         * @param {number} id The id of the company to retrieve
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyIdPut(id: number, company?: Company, options?: any): AxiosPromise<Company> {
            return localVarFp.companyIdPut(id, company, options).then((request) => request(axios, basePath));
        },
        /**
         * Save default consultants for company
         * @param {CompanySaveconsultantsorderPostRequest} companySaveconsultantsorderPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companySaveconsultantsorderPost(companySaveconsultantsorderPostRequest: CompanySaveconsultantsorderPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.companySaveconsultantsorderPost(companySaveconsultantsorderPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all consultants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getconsultantsGet(options?: any): AxiosPromise<Person> {
            return localVarFp.getconsultantsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all parent companies
         * @param {string} [companyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parentCompaniesGet(companyType?: string, options?: any): AxiosPromise<Company> {
            return localVarFp.parentCompaniesGet(companyType, options).then((request) => request(axios, basePath));
        },
        /**
         * save extra costs for l1 and damageassessors
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveExtraCostsPut(body: object, options?: any): AxiosPromise<void> {
            return localVarFp.saveExtraCostsPut(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Update company data
         * @param {number} wmi the wmi of the manufacturer
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wmiWmiPut(wmi: number, company?: Company, options?: any): AxiosPromise<Company> {
            return localVarFp.wmiWmiPut(wmi, company, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     * Get a all child companies of authed user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public childCompaniesGet(options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).childCompaniesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific company
     * @param {number} id The id of the company to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public childCompaniesIdGet(id: number, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).childCompaniesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a company sign
     * @param {number} id The id of the company to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companyIdCompanysignGet(id: number, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companyIdCompanysignGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to delete a company
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companyIdDelete(id: number, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companyIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get company employees
     * @param {number} id The id of the company to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companyIdEmployeesGet(id: number, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companyIdEmployeesGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific company
     * @param {number} id The id of the company to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companyIdGet(id: number, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companyIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update company data
     * @param {number} id The id of the company to retrieve
     * @param {Company} [company] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companyIdPut(id: number, company?: Company, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companyIdPut(id, company, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save default consultants for company
     * @param {CompanySaveconsultantsorderPostRequest} companySaveconsultantsorderPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companySaveconsultantsorderPost(companySaveconsultantsorderPostRequest: CompanySaveconsultantsorderPostRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companySaveconsultantsorderPost(companySaveconsultantsorderPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all consultants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public getconsultantsGet(options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).getconsultantsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all parent companies
     * @param {string} [companyType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public parentCompaniesGet(companyType?: string, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).parentCompaniesGet(companyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * save extra costs for l1 and damageassessors
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public saveExtraCostsPut(body: object, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).saveExtraCostsPut(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update company data
     * @param {number} wmi the wmi of the manufacturer
     * @param {Company} [company] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public wmiWmiPut(wmi: number, company?: Company, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).wmiWmiPut(wmi, company, options).then((request) => request(this.axios, this.basePath));
    }
}
